module.exports = __webpack_public_path__ + "img/krojaceva_skola.aaed4364.png";